define('order_wizard_promocodenotifications.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('order_wizard_promocodenotifications', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return " \n";
},"useData":true}, 'extensions/SuiteCommerce/Suite_Commerce_Base_Theme/26.1.1/', 'extensions/SuiteCommerce/Suite_Commerce_Base_Theme/26.1.1/', Handlebars);
});